import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {LibraryParameterDefinitionTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';
import {LibraryParameterDefinitionIdName} from 'procedures/parameter-library/ParameterLibraryTypes';

export function libraryDefinitionToTypedValue(
  def: LibraryParameterDefinitionIdName
): LibraryParameterDefinitionTypedValue {
  return {
    type: BaseTypedValueType.LIBRARY_PARAMETER_DEFINITION as 'LIBRARY_PARAMETER_DEFINITION',
    id: def.id,
    name: def.name,
  };
}

export function getLibraryDefinitionTypedValue(
  typedValue: TypedValue | null | undefined
): LibraryParameterDefinitionTypedValue | null {
  if (typedValue?.type === BaseTypedValueType.LIBRARY_PARAMETER_DEFINITION) {
    return typedValue;
  }
  return null;
}
